module.exports = __webpack_public_path__ + "img/the_ellimal_egos.b0eabd0d.png";